import axios from 'axios';
import AxiosInstance from '../config/AxiosInstance';

interface saleDetailsPayload {
    salesId: string,
    sequenceNo: number,
    recordType: number,
    articleId?: string,
    itemName: string,
    quantity: number,
    price: number,
    discount?: number,
    net?: number,
    tax?: number,
    amount?: number,
    cost?: number,
    taxId?: string,
    productPriceId: string,
    note?: string,
    isActive?: boolean,
    isDeleted?: boolean,
    createdBy: string,
    updatedAt?: Date,
}

interface SalesPayload {
    clientId: string,
    salesType: string,
    reference: string,
    issuedOn: Date,
    dueDate: Date,
    companyId: string,
    locationId: string,
    quantity: number,
    price: number,
    tax: number,
    discount: number,
    note: string,
    termId: string,
    statusId: string,
    createdBy: string,
    invoiceNumber: string,
    updatedBy: string,
    updatedAt: Date,
    createdAt: Date,
    saleDetails: saleDetailsPayload[]
}


const createSales = async (payload: any) => {
    // type: any,
    try {
        // const { data } = await AxiosInstance.post('/api/finex/sales/' + type, payload);
        const { data } = await AxiosInstance.post('/api/finex/sales', payload);
        return { data };
    } catch (error) {
        throw error;
    }
};

const getListProduct = async (page: any, limit: any, searchValue: any, companyId: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/inventory/products/list', {
            params: {
                page: page,
                limit: limit,
                searchValue: searchValue,
                companyId: companyId,
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}

const getSales = async (page: any, limit: any, searchValue: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/finex/sales', {
            params: {
                page: page,
                limit: limit,
                searchValue: searchValue
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
};

const getInvoiceNumber = async () => {
    try {
        const { data } = await AxiosInstance.get('/api/finex/sales/invoiceNumber');
        return { data };
    } catch (error) {
        throw error;
    }
}

const getPaymentType = async () => {
    try {
        const { data } = await AxiosInstance.get('api/finex/payments-type');
        return { data };
    } catch (error) {
        throw error;
    }
};

const getDetailSales = async (id: string) => {
    try {
        const { data } = await AxiosInstance.get('/api/finex/sales/' + id);
        return { data };
    } catch (error) {
        throw error;
    }
};

const updateSales = async (id: string, payload: any) => {
    // type: any, 
    try {
        const { data } = await AxiosInstance.put('/api/finex/sales/' + id, payload);
        // const { data } = await AxiosInstance.put('/api/finex/sales/' + type + "/" + id, payload);
        return { data };
    } catch (error) {
        throw error;
    }
};

const updateStatus = async (id: string, payload: any) => {
    // type: any, 
    try {
        const { data } = await AxiosInstance.put('/api/finex/sales/updateStatus/' + id, payload);
        // const { data } = await AxiosInstance.put('/api/finex/sales/' + type + "/" + id, payload);
        return { data };
    } catch (error) {
        throw error;
    }
};

const deleteSales = async (id: string) => {
    try {
        const { data } = await AxiosInstance.delete('/api/finex/sales/' + id);
        return { data };
    } catch (error) {
        throw error;
    }
};


const createSalesPayment = async (payload: any) => {
    try {
        const { data } = await AxiosInstance.post('/api/finex/sales/sale-payments', payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

const updateSalesPayment = async (id: string, payload: any) => {
    try {
        const { data } = await AxiosInstance.post('/api/finex/sales/sale-payments/' + id, payload);
        return { data };
    } catch (error) {
        throw error;
    }
}


export {
    createSales,
    getSales,
    deleteSales,
    getDetailSales,
    updateSales,
    getPaymentType,
    updateSalesPayment,
    createSalesPayment,
    updateStatus,
    getInvoiceNumber,
    getListProduct
}